module.exports = __webpack_public_path__ + "img/19.6.CODm.2dc3a397.png";